var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M20.93 13.44a8.995 8.995 0 11-1.548-6.663l-7.31 7.28-3.087-3.088","stroke":"#B503D0","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }